import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=3a2d65aa&scoped=true&"
import script from "./MessageView.vue?vue&type=script&lang=ts&"
export * from "./MessageView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageView.vue?vue&type=style&index=0&id=3a2d65aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2d65aa",
  null
  
)

export default component.exports